import React from "react"
import PropTypes from "prop-types"
import Icon from "../icon-v2"

const Button = ({
  className,
  label,
  accessibilityLabel,
  icon,
  iconType,
  link,
  linkBehavior,
  variant,
  spacing,
  fullWidth,
}) => (
  <a
  data-name="button-anchor"
    className={`
      ${className} 
      button-v2 button-v2${variant}
      ${spacing ? " button-v2--spacing" : ""}
      ${icon ? " button-v2--has-icon" : ""}
      ${fullWidth ? " button-v2--full-width" : ""}
    `}
    href={link}
    title={accessibilityLabel || label}
    target={linkBehavior ? "_blank" : ""}
    rel={linkBehavior ? "noreferrer": ""}
  >
    <span className="button-v2__label">{label}</span>
    {icon &&  (
      <div className="button-v2__icon">
        <Icon iconType={iconType} icon={icon} size="16" />
      </div>
    )}
  </a>
)

Button.defaultProps = {
  className: "",
  label: "",
  accessibilityLabel: "",
  icon: "",
  link: "#",
  linkBehavior: false,
  variant: "--text",
  spacing: false,
}

Button.propTypes = {
  className: PropTypes.string,
  label: PropTypes.string,
  accessibilityLabel: PropTypes.string,
  icon: PropTypes.string,
  link: PropTypes.string,
  linkBehavior: PropTypes.bool,
  variant: PropTypes.string,
  spacing: PropTypes.bool,
}

export default Button
